import { useState } from "react";

import { Box, Grid, Modal } from "@mui/material";
import SipLongLogo from "../image/sip_long_logo.png";
import LogoGaBig from "../assets/images/ga/logo-ga-big.png";

const programName = window.location.href.indexOf("fa-ga") > 0 ? "ga" : "sa";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1200,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  height: "610px",
  overflowY: "scroll",
  p: 2,
};

const MessageModal = ({ message }: any) => {
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Grid
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3, lg: 4 }}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <div className="center">
              <img
                src={programName === "ga" ? LogoGaBig : SipLongLogo}
                style={{ height: "54px" }}
                alt="Logo"
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <div className="center">
              <div style={{ fontSize: "35px", padding: "35px" }}>{message}</div>
            </div>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default MessageModal;
